import { TravelstatusMdl } from "./TravelBindMdl";

export class TravelPromoMdl{
    public  RegNo:string;
    public  IqamaNo:string;
    public  PromoCode :string;   
    public  PromoPercent:string;
    public  TotalPremium:string;
    public  TotalPremiumBVAT:string 
    public  VATAmt :string;
    public  AvailedAmt :string;
    public  isPromoApply:string;
    public  PromoType :string;

   //
    public  DICOUNTFLAG:Boolean; 
    public  DISCOUNT_PER :number;
    public  DISCOUNT_FLAT :number;
    public  PROMOID :number;
    public  DISCOUNTTYPE :string;
    // public st:TravelstatusMdl=new TravelstatusMdl();
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/TravelPromoMdl.ts